import React from "react";
import Text from "@/components/ui/text";
import IconContainer from "@/components/ui/icon-container";
import { InfoCircle } from "@dreamhub/designsystem/icons";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from "@/components/ui/tooltip";

interface Props {
  tooltipText?: string | null;
}

// Info-circle tooltip for field help text. The trigger is a real <button> so it
// is keyboard-focusable. enableMarkdown is off explicitly: the text is
// user-authored and must render as escaped plain text, not markdown.
export const HelpTextTooltip: React.FC<Props> = ({ tooltipText }) =>
  tooltipText ? (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          className="ml-1 inline-flex items-center border-0 bg-transparent p-0"
          aria-label="Help"
          data-test="help-text-tooltip"
        >
          <IconContainer size="sm" color="secondary">
            <InfoCircle />
          </IconContainer>
        </button>
      </TooltipTrigger>
      <TooltipContent maxWidth={13} enableMarkdown={false}>
        <Text variant="smBody">{tooltipText}</Text>
      </TooltipContent>
    </Tooltip>
  ) : null;
